import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../contexts/ToastContext';
import departmentService from '../services/departmentService';
import './JoinDepartment.css';

function JoinDepartment() {
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [joined, setJoined] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = code.trim();
    if (!trimmed) {
      addToast('Please enter a join code', 'error');
      return;
    }

    setLoading(true);
    try {
      const data = await departmentService.joinDepartment(trimmed);
      setJoined(data);
      addToast(`You joined ${data.name}`, 'success');
    } catch (err) {
      addToast(err.message || 'Failed to join department', 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  if (joined) {
    return (
      <div className="join-department">
        <h1>Welcome to {joined.name}</h1>
        <div className="success-card">
          <p>You are now a responder for this department.</p>
          <button
            type="button"
            className="submit-button"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="join-department">
      <h1>Join a Department</h1>
      <p className="subtitle">Enter the join code you received from your chief.</p>

      <form onSubmit={handleSubmit} className="join-form">
        <label>
          Join code
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="ABCD1234"
            autoComplete="off"
          />
        </label>

        <div className="button-row">
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Joining...' : 'Join Department'}
          </button>
          <button type="button" className="cancel-button" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default JoinDepartment;
